// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1hJIz","signatureButtonsRight":"ModalSign_signatureButtonsRight__36gS8"};